<div [ngClass]="{ 'form-row': to?.className === 'xilo-input' }">
  <div [ngClass]="{ 'form-item': to?.className === 'xilo-input' }">
    <p [ngStyle]="styleText()">{{ to?.label }}</p>
  </div>
</div>
<p [ngStyle]="styleCalcVal()" class="text-base">{{ display || '' }}</p>
